import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import SimpleListing from '@client/components/listings/simpleListing/SimpleListing';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import { selectHlfArticleListing } from '@client/redux/commonData/commonDataReducer';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import ArticleCard from '@client/containers/articleCard/ArticleCard';
import styles from './moreFromHlf.scss';

function MoreFromHlf({ className, hlfArticleListing }) {
  const hlfFundraiserListingTitle = getIn(hlfArticleListing, 'title');

  return (
    <div className={`${styles.moreFromHlf}${className ? ` ${className}` : ''}`}>
      <div className={styleHelper.contentContainer}>
        <h3
          className={`${styleHelper.titleMdPrimary} ${styles.moreFromHlfTitle}`}
        >
          {hlfFundraiserListingTitle}
        </h3>
        <div className={styleHelper.alignmentContainer}>
          <SimpleListing
            className={styleHelper.cardListGrid}
            list={getIn(hlfArticleListing, 'listing')}
            ListItemComponent={ArticleCard}
            listItemProps={{
              itemObjName: 'article',
              fluidImage: true,
            }}
          />
        </div>
      </div>
    </div>
  );
}

MoreFromHlf.propTypes = {
  className: PropTypes.string,
  hlfArticleListing: ImmutablePropTypes.map,
};

function mapStateToProps(state) {
  return {
    hlfArticleListing: selectHlfArticleListing(state),
  };
}

export default connect(mapStateToProps)(MoreFromHlf);
